import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@env';
import { DataListParameter } from '@shared/interfaces/data-list-parameter.interface';
import { map, Observable, take } from 'rxjs';

const apiUrl = environment.apiUrl;
@Injectable({
  providedIn: 'root',
})
export class BeautybookService {
  private guestBeautybookPostAPIRoute: string =
    apiUrl + 'guest/beauty_book_post/';
  private userBeautybookPostAPIRoute: string =
    apiUrl + 'user/beauty_book_post/';
  private userBeautybookPostCommentAPIRoute: string =
    apiUrl + 'user/beauty_book_comment/';
  private guestBeautybookProductAPIRoute: string =
    apiUrl + 'guest/beauty_book_product/';
  private userBeautybookSelfieAPIRoute: string =
    apiUrl + 'user/beauty_book_selfie/';
  private userBeautybookLikeAPIRoute: string =
    apiUrl + 'user/beauty_book_like/';

  constructor(private http: HttpClient, private router: Router) {}

  getBeautybookPosts(dataListParameter: DataListParameter) {
    return this.http
      .post(this.guestBeautybookPostAPIRoute + 'search', dataListParameter)
      .pipe(
        take(1),
        map((res: any) => {
          return res.data.beauty_book_posts;
        })
      );
  }
  getBeautybookPost(id: number) {
    return this.http.get(this.guestBeautybookPostAPIRoute + id).pipe(
      take(1),
      map((res: any) => res.data)
    );
  }
  addBeautybookPost(data: any) {
    return this.http.post(this.userBeautybookPostAPIRoute, data);
  }
  applyLipstick(data: any) {
    return this.http.post('https://happybeauty.co.id/beautybook.php', data);
  }

  getBeautybookProducts(dataListParameter: DataListParameter) {
    return this.http
      .post(this.guestBeautybookProductAPIRoute + 'search', dataListParameter)
      .pipe(
        take(1),
        map((res: any) => res.data.beauty_book_products)
      );
  }
  getBeautybookProductVariant(productId: number) {
    return this.http
      .get(this.guestBeautybookProductAPIRoute + 'variants/' + productId)
      .pipe(
        take(1),
        map((res: any) => res.data)
      );
  }
  getSelfies() {
    const param: DataListParameter = {
      item_per_page: 1000,
      current_page: 1,
    };
    return this.http
      .post(this.userBeautybookSelfieAPIRoute + 'search', param)
      .pipe(
        take(1),
        map((res: any) => {
          let selfies = res;
          selfies['data']['beautybook_selfies'].forEach((selfie: any) => {
            selfie.valid = selfie.face_landmarks.length > 0 ? true : false;
          });
          return selfies['data']['beautybook_selfies'];
        })
      );
  }
  getSelfie(id: number) {
    return this.http.get(this.userBeautybookSelfieAPIRoute + id).pipe(take(1));
  }
  uploadSelfie(selfie: any) {
    return this.http.post(this.userBeautybookSelfieAPIRoute, selfie).pipe(
      map((res: any) => {
        return res.data[0];
      })
    );
  }
  deleteSelfie(id: number) {
    return this.http.delete(this.userBeautybookSelfieAPIRoute + id);
  }
  like(id: number, type: any) {
    const data = {
      likeable_id: id,
      likeable_type: type,
    };
    return this.http.post(this.userBeautybookLikeAPIRoute + 'like', data);
  }
  liked(id: number, type: any) {
    const data = {
      likeable_id: id,
      likeable_type: type,
    };
    return this.http.post(
      this.userBeautybookLikeAPIRoute + 'already_liked',
      data
    );
  }
  unlike(id: number, type: any) {
    const data = {
      likeable_id: id,
      likeable_type: type,
    };
    return this.http.post(this.userBeautybookLikeAPIRoute + 'unlike', data);
  }

  getComments(id: number, dataListParameter: DataListParameter) {
    return this.http
      .post(
        this.guestBeautybookPostAPIRoute + 'comments/' + id,
        dataListParameter
      )
      .pipe(
        take(1),
        map((res: any) => res.data.beauty_book_comments)
      );
  }
  postComment(id: number, comment: any) {
    const data = {
      comment: comment,
      commentable_id: id,
      commentable_type: 'posts',
    };
    return this.http.post(this.userBeautybookPostCommentAPIRoute, data);
  }
  deleteComment(id: number) {
    return this.http.delete(this.userBeautybookPostCommentAPIRoute + id);
  }

  getBlob(url: string): Observable<Blob> {
    return this.http.get<Blob>(url, {
      observe: 'body',
      responseType: 'blob' as 'json',
    });
  }
}
